export class QuoteException extends Error {

}
